import {
    Component,
    EventEmitter,
    Output,
} from "@angular/core";
import { PhotoService } from "../../services/photo.service";
import { SharedDataService } from "../../services/shared-data.service";
import {
    ActionSheetController,
    ModalController,
    NavController,
    AlertController
} from "@ionic/angular";
import { StaticDataService } from "../../services/static-data.service";
import {
    MediaCapture,
    MediaFile,
    CaptureError,
    CaptureVideoOptions,
} from "@ionic-native/media-capture/ngx";
import { Capacitor } from "@capacitor/core";
import { FilehandlerService } from "src/app/services/filehandler.service";
import { UtilService } from "src/app/services/util.service";
import { TranslateService } from "@ngx-translate/core";
import { VideorecordPage } from "src/app/modals/videorecord/videorecord.page";

@Component({
  selector: "app-attachement-extension",
  templateUrl: "./attachement-extension.component.html",
  styleUrls: ["./attachement-extension.component.scss"],
})
export class AttachementExtensionComponent {
    @Output() attachementArray: EventEmitter<any[]> = new EventEmitter<any[]>();
    window = window;

    StaticDataService = StaticDataService;
    UtilService = UtilService;
    Capacitor = Capacitor;
    image: any;
    videoUrl;
    attachementList = [];
    selectedFile: File | null = null;

    isWebApp: Boolean = UtilService.isWebApp();
    

    constructor(
        public photoService: PhotoService,
        private mediaCapture: MediaCapture,
        public navCtrl: NavController,
        public translateService: TranslateService,
        public utilService: UtilService,
        public filehandlerService: FilehandlerService,
        public sharedDataService: SharedDataService,
        public actionSheetController: ActionSheetController,
        public modalController: ModalController,
        private alertController: AlertController
    ) { }

    // ngOnChanges(changes: SimpleChanges): void {
    //     // if (this.defaultValue) {
    //     //     for (let i = 0; i < this.defaultValue.length; i++) {
    //     //         const globalCurrentValue = this.defaultValue[i];
    //     //         const currentDefaultValue = this.defaultValue[i].attachement; 

    //     //         let extension = "";
    //     //         if (currentDefaultValue.type) {
    //     //             extension = currentDefaultValue.name.split('.').pop() || '';
    //     //             this.attachementList.push(globalCurrentValue);
    //     //             this.photoThumbnailList.push(null)   
    //     //             this.expandedList.push(null)
    //     //             //this.namesList.push(currentDefaultValue.name);
    //     //             this.isVideoList.push(false)
    //     //           }
    //     //     else if (UtilService.IsBase64Sring(currentDefaultValue)) {
    //     //         extension = currentDefaultValue.match(/[^:/]\w+(?=;|,)/)[0];
    //     //     } else {
    //     //         extension = currentDefaultValue.split(".").pop().toLowerCase();
    //     //         }
    //     //         if(!currentDefaultValue.type){

    //     //     if (
    //     //         StaticDataService.supportedVideoFormats.indexOf(extension) !==
    //     //         -1
    //     //     ) {
    //     //         this.isVideoList.push(true);
    //     //         this.attachementList.push(globalCurrentValue);
    //     //         this.expandedList.push(true);
    //     //         this.photoThumbnailList.push(null);
    //     //         //this.namesList.push('bb');
    //     //         //this.isVideo = true;
    //     //          //this.videoUrl = Capacitor.convertFileSrc(this.defaultValue);
    //     //     } else {
    //     //         // this.photoThumbnailList = Capacitor.convertFileSrc(
    //     //         //     this.defaultValue
    //     //         // );
    //     //         this.photoThumbnailList.push(Capacitor.convertFileSrc(
    //     //             currentDefaultValue
    //     //         ));
    //     //         this.attachementList.push(globalCurrentValue);
    //     //         this.isVideoList.push(false);
    //     //         this.expandedList.push(true);
    //     //         //this.namesList.push('aa');

    //     //         //this.image = Capacitor.convertFileSrc(this.defaultValue);
    //     //     }
    //     // }
    //     //     }
    //     //     this.onChange(this.attachementList);

    //     // }
    // }
    // registerOnChange(fn: any): void {
    //     this.onChange = fn;
    // }

    // ngOnDestroy(): void {
    //     //this.image = null;
    //     this.attachementList = null;
    //     this.photoThumbnailList = []   
    //     this.expandedList = [];
    //     this.isVideoList = [];
    //     this.namesList = [];

    //     //this.photoThumbnail = null;
    // }

    // registerOnTouched(fn: any): void {
    //     this.onTouch = fn;
    // }

    writeValue(obj: any, name = '', isVideo = false,photoThumbnail=null): void {
        if (Array.isArray(obj)) return ; 
         if (obj) {
            //this.attachementList.push({ attachement: obj, name: name });
            this.attachementList = [...this.attachementList, {
                attachement: obj, name: name, expanded: true,
                photoThumbnail: isVideo?null:photoThumbnail, isVideo: isVideo
            }]
            this.attachementArray.emit(this.attachementList);
            //this.expandedList.push(true);
            // if (isVideo) {
            //     this.photoThumbnailList.push(null);
            // }
            // this.isVideoList.push(isVideo);

        }

        //this.image = obj;
    }

    // editPhoto(index) {
    //     this.openImageAnnotation(Capacitor.convertFileSrc(this.attachementList[index].attachement),index);
    // }

    // expandImage(index) {
    //     this.expandedList[index]=!this.expandedList[index]
    // }

    // photoRemoved(index) {
    //     this.attachementList.splice(index, 1);
    //     this.photoThumbnailList.splice(index, 1);
    //     this.expandedList.splice(index, 1);
    //     this.namesList.splice(index, 1);
    //     this.isVideoList.splice(index, 1);
    //     if (this.attachementList.length === 0) { 
    //         this.onChange(null);
    //     }
    //     else {
    //         this.onChange(this.attachementList);
    //     }

    //     //this.photoAdded(null);
    // }

    photoAdded(photo,name='',isVideo=false,photoThumbnail = null) {
        this.writeValue(photo,name,isVideo,photoThumbnail);
    }

    addPhotoFromCamera() {
        this.sharedDataService.isGalleryOrCameraOpened = true;
        this.photoService.takePhotoFromNativeCamera((photo) => {
            //this.isVideo = false;
            this.sharedDataService.isGalleryOrCameraOpened = false;
            this.savePhoto(photo.dataUrl,`camera photo ${(this.attachementList.length+1)}`);
        });
    }

    async addVideoFromCamera() {
        if (UtilService.isWebApp() || UtilService.isLocalHost()) {
            const modal = await this.modalController.create({
                component: VideorecordPage,
                showBackdrop: false,
                backdropDismiss: false,
                animated: true,
                componentProps: {},
                cssClass: "video-record-modal",
            });
            await modal.present();

            modal.onWillDismiss().then(({ data }) => {
                if (data.status) {
                    //this.isVideo = true;
                    //this.isVideoList.push(true);
                    const videoData = data.data;
                    this.videoUrl = videoData;
                    this.photoAdded(videoData, `camera video ${(this.attachementList.length+1)}`,true,null);
                }
            });
        } else {
            this.sharedDataService.isGalleryOrCameraOpened = true;
            const options: CaptureVideoOptions = { limit: 1, duration: 3600 };
            this.mediaCapture.captureVideo(options).then(
                (data: MediaFile[]) => {
                    this.sharedDataService.isGalleryOrCameraOpened = false;
                    //this.isVideo = true;
                    //this.isVideoList.push(true);
                    const capturedFile = data[0];
                    const videoUrl = capturedFile.fullPath;
                    this.videoUrl = Capacitor.convertFileSrc(videoUrl);
                    //this.isVideoList.push(true);    
                    this.photoAdded(videoUrl, 'camera video '+ this.attachementList.length+1,true,null);
                },
                (err: CaptureError) => {
                    this.sharedDataService.isGalleryOrCameraOpened = false;
                    console.error(err);
                }
            );
        }
    }

    async choosePhotoVideoOption() {
        const actionSheet = await this.actionSheetController.create({
            header: "Choose option",
            cssClass: "my-custom-class",
            buttons: [
                {
                    text: "Photo",
                    icon: "camera-outline",
                    handler: () => {
                        this.addPhotoFromCamera();
                    },
                },
                {
                    text: "Video",
                    icon: "videocam-outline",
                    handler: () => {
                        this.addVideoFromCamera();
                    },
                },
                {
                    text: "Cancel",
                    icon: "close",
                    role: "cancel",
                    handler: () => { },
                },
            ],
        });
        await actionSheet.present();
    }
    onFileSelected(event: any): void {
        const file = event.target.files[0];
        if (file) {
          this.selectedFile = file;
        }
    }
    triggerFileInput() {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        fileInput.onchange = (event: any) => {
          const file = event.target.files[0];
            if (file) {
                this.attachementList = [...this.attachementList, {
                    attachement: file, name: file.name, expanded: null,
                    photoThumbnail: null, isVideo: false
                }]
                this.attachementArray.emit(this.attachementList);
          }
        };
        fileInput.click();
      }

    onUpload(): void { 
        const formData = new FormData();
        formData.append('file', this.selectedFile, this.selectedFile.name);
    }
    async addFileLibrary() {
        const alert = await this.alertController.create({
          header: 'Choose Upload Option',
          buttons: [
            {
              text: 'Upload File',
              handler: () => {
                this.triggerFileInput();
              }
            },
            {
              text: 'Upload Media',
              handler: () => {
                this.addPhotoFromLibrary();
              }
              },    
              {
                text: 'Take photo/video',
                handler: () => {
                    this.isWebApp ? this.addPhotoFromCamera() : this.choosePhotoVideoOption();
                }
                },
              
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary'
            }
          ]
        });
    
        await alert.present();
      }
      async addPhotoFromLibrary() {
        const onPhotoVideoAdded = async (urlOrBase64Data, isVideo, name) => {   
            let extension = "";
            if (UtilService.IsBase64Sring(urlOrBase64Data)) {
                extension = urlOrBase64Data.match(/[^:/]\w+(?=;|,)/)[0];
            } else {
                extension = urlOrBase64Data.split(".").pop().toLowerCase();
            }
    
            if (isVideo) {
                if (StaticDataService.supportedVideoFormats.indexOf(extension) === -1) {
                    this.translateService.get("SHARED_TEXT.MEDIA.VIDEO_FORMAT_NOT_SUPPORTED")
                        .subscribe((res) => {
                            this.utilService.showAlert(res);
                        });
                } else {
                    const videoUrl = urlOrBase64Data;
                    if (UtilService.isWebApp() || UtilService.isLocalHost()) {
                        this.videoUrl = videoUrl;
                        this.photoAdded(videoUrl, name, true, null);
                    } else {
                        try {
                            const response:any = await this.filehandlerService.saveFileOnDevicePath(
                                videoUrl,
                                StaticDataService.formImagesFolderName
                            );
                            this.photoService.cleanCamera();
                            this.videoUrl = Capacitor.convertFileSrc(response);
                            this.photoAdded(this.videoUrl, name, true, null);
                        } catch (error) {
                            console.error("Error saving file on device path", error);
                            this.photoService.cleanCamera();
                            this.videoUrl = Capacitor.convertFileSrc(videoUrl);
                            this.photoAdded(this.videoUrl, name, true, null);
                        }
                    }
                }
            } else {
                if (StaticDataService.supportedImageFormats.indexOf(extension) === -1) {
                    this.translateService.get("SHARED_TEXT.MEDIA.IMAGE_FORMAT_NOT_SUPPORTED")
                        .subscribe((res) => {
                            this.utilService.showAlert(res);
                        });
                } else {
                    this.savePhoto(urlOrBase64Data, name);
                }
            }
        };
    
        if (UtilService.isWebApp() || UtilService.isLocalHost()) {
            this.photoService.chooseMediaFromAlbum(async (result, type, name) => {
                await onPhotoVideoAdded(result, type === "video", name);
            });
        } else {
            this.sharedDataService.isGalleryOrCameraOpened = true;
            this.photoService.takePhotoFromGallery(
                async (photo, name) => {
                    this.sharedDataService.isGalleryOrCameraOpened = false;
                    await onPhotoVideoAdded(photo.dataUrl, photo.isVideo, name);
                },
                true,
                true
            );
        }
    }
    

    // sanitize(url: string): SafeUrl {
    //     return this.sanitizer.bypassSecurityTrustUrl(url);
    // }

    // // Allow the Angular form control to disable this input
    // setDisabledState(disabled: boolean): void {
    //     this.disabled = disabled;
    // }

    // openImageAnnotation = (photo,index) => {
    //     this.sharedDataService.isOpenSubScreen = true;
    //     this.sharedDataService.setAnnotationImage(photo);
    //     this.sharedDataService.onAnnotationImageDone = (image) => {
    //         this.savePhoto(image,index);
    //         this.sharedDataService.setAnnotationImage(null);
    //         this.sharedDataService.onAnnotationImageDone = null;
    //     };
    //     this.navCtrl.navigateForward(["/image-annotation"]);
    // };

    async savePhoto(imageBase64, name = '') {
        if (UtilService.isWebApp() || UtilService.isLocalHost()) {
            this.utilService.generateThumbnailFromImage(
                imageBase64,
                500,
                500,
                0.5,
                (data) => {
                    this.photoAdded(imageBase64, name, false, data);
                }
            );
        } else {
            this.utilService.generateThumbnailFromImage(
                UtilService.IsBase64Sring(imageBase64)
                    ? imageBase64
                    : Capacitor.convertFileSrc(imageBase64),
                500,
                500,
                0.25,
                async (data) => {
                    this.photoAdded(data, name, false, data);
                    try {
                        const response = await this.filehandlerService.saveFileOnDevicePath(
                            imageBase64,
                            StaticDataService.formImagesFolderName
                        );
                        this.photoService.cleanCamera();
                        if (response) {
                            // Uncomment the following line if you need to add the photo
                            // this.photoAdded(response, null, name, false);
                        }
                    } catch (error) {
                        console.error("Error saving file on device path", error);
                        this.photoService.cleanCamera();
                        // Handle the error as needed
                    }
                }
            );
        }
    }
    
}
